module.exports = __webpack_public_path__ + "img/mathematics_base.f99f2596.svg";